import { InjectionToken } from '@angular/core';

export const COMPANY_CONFIG_RAW = new InjectionToken('COMPANY_CONFIG_RAW');

export const COMPANY_VENDOR_ID = new InjectionToken('COMPANY_VENDOR_ID');
